import { useFeatures } from "@/lib/features";
import { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { NAV } from "@/data/spa";
import { useContent } from "@/lib/content";
import { BookLink } from "@/lib/fresha";
import { InstallBar } from "./InstallBar";

export const Logo = ({ testId, variant = "black" }) => (
  <a className={`logo logo-${variant}`} href="#home" data-testid={testId}>
    <img src={`/brand/logo-${variant}.png`} alt="Wax Moi Day Spa" width="835" height="240" />
  </a>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { data: c } = useContent();
  const f = useFeatures();
  const nav = NAV.filter((n) => !f || f[{ "/shop": "shop", "/our-work": "work" }[n.href]] !== false);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <>
      <InstallBar />
      <div className="announcement" data-testid="announcement-bar">
        {c.announcement.text} <a href={`tel:${c.contact.phone_call}`} data-testid="announcement-call-link">{c.announcement.link_label}</a>
      </div>
      <header className="nav">
        <Logo testId="header-logo" />
        <nav className="navlinks">
          {nav.map((n) => (
            <a key={n.href} href={n.href} data-testid={`nav-link-${n.href.slice(1)}`}>{n.label}</a>
          ))}
          <BookLink className="btn gold" testId="nav-book-button">Book an Appointment <ArrowUpRight size={14} /></BookLink>
        </nav>
        <button className="hamb" aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open}
          onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </header>
      <nav className={`mobilemenu ${open ? "open" : ""}`} data-testid="mobile-menu" aria-hidden={!open}>
        {nav.map((n, i) => (
          <a key={n.href} href={n.href} onClick={() => setOpen(false)} style={{ transitionDelay: `${open ? 60 * i + 80 : 0}ms` }}
            data-testid={`mobile-nav-link-${n.href.slice(1)}`}>{n.label}</a>
        ))}
        <BookLink className="btn gold" onClick={() => setOpen(false)} testId="mobile-nav-book-button">Book an Appointment</BookLink>
        <a className="btn light" href={`tel:${c.contact.phone_call}`} data-testid="mobile-nav-call-button">Call the spa</a>
      </nav>
    </>
  );
};
